import { createSlice } from "@reduxjs/toolkit";

export const pests_image_library = createSlice({
  name: "pests_image_library",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStorePestsImageLibary: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStoreDiseaseImageLibary } = pests_image_library.actions;

export default pests_image_library.reducer;
